import { Link } from 'react-router-dom';
import { GiChessKnight, GiCardRandom, GiDiceTwentyFacesTwenty, GiMeeple, GiSwapBag, GiPaintBrush } from 'react-icons/gi';

const categories = [
  {
    name: 'Juegos de Tablero',
    description: 'Estrategia, conquista y aventuras épicas sobre el tablero.',
    icon: GiChessKnight,
    color: 'from-df-accent to-purple-700',
    path: '/productos?tipo=Tablero',
  },
  {
    name: 'Juegos de Cartas',
    description: 'Mazos, combos y bluffing para partidas rápidas e intensas.',
    icon: GiCardRandom,
    color: 'from-df-cyan to-df-accent',
    path: '/productos?tipo=Cartas',
  },
  {
    name: 'Juegos de Dados',
    description: 'Azar, suerte y decisiones rápidas con cada lanzamiento.',
    icon: GiDiceTwentyFacesTwenty,
    color: 'from-emerald-500 to-emerald-700',
    path: '/productos?tipo=Dados',
  },
  {
    name: 'Juegos de Rol',
    description: 'Crea tu personaje, vive la aventura y forja tu propia historia.',
    icon: GiMeeple,
    color: 'from-amber-500 to-orange-600',
    path: '/productos?tipo=Rol',
  },
  {
    name: 'Miniaturas',
    description: 'Figuras coleccionables y juegos tácticos a escala.',
    icon: GiPaintBrush,
    color: 'from-rose-500 to-red-600',
    path: '/productos?tipo=Miniaturas',
  },
  {
    name: 'Accesorios',
    description: 'Dados, fundas, tapetes y todo lo que necesitas para jugar.',
    icon: GiSwapBag,
    color: 'from-df-gold to-yellow-600',
    path: '/productos',
  },
];

export default function CategoryGrid() {
  return (
    <section className="df-section bg-df-bg relative">
      {/* Subtle top border glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-1/2 h-px bg-gradient-to-r from-transparent via-df-accent/30 to-transparent" />

      <div className="container mx-auto px-4">
        {/* Section header */}
        <div className="text-center mb-12">
          <h2 className="font-cinzel text-3xl md:text-4xl font-bold text-df-text mb-4">
            Explora por{' '}
            <span className="text-df-accent">Categoría</span>
          </h2>
          <p className="text-df-muted max-w-xl mx-auto">
            Encuentra el tipo de juego perfecto para tu próxima noche de mesa.
          </p>
        </div>

        {/* Category grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {categories.map((cat) => {
            const Icon = cat.icon;
            return (
              <Link
                key={cat.name}
                to={cat.path}
                className="group df-card p-6 flex items-start gap-4 hover:scale-[1.02] transform transition-all duration-300"
              >
                {/* Icon */}
                <div
                  className={`flex-shrink-0 w-14 h-14 rounded-xl bg-gradient-to-br ${cat.color} flex items-center justify-center shadow-lg group-hover:shadow-xl transition-shadow`}
                >
                  <Icon className="text-2xl text-white" />
                </div>

                {/* Text */}
                <div className="flex-1 min-w-0">
                  <h3 className="text-lg font-semibold text-df-text group-hover:text-df-accent transition-colors mb-1 font-sans">
                    {cat.name}
                  </h3>
                  <p className="text-sm text-df-muted leading-relaxed">
                    {cat.description}
                  </p>
                </div>

                {/* Arrow */}
                <svg
                  className="w-5 h-5 text-df-muted group-hover:text-df-accent transition-all duration-300 group-hover:translate-x-1 flex-shrink-0 mt-1"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
